const ArrowBack = props => (
  <svg viewBox="0 0 6 10" {...props}>
    <path d="M5.19 10a.8.8 0 0 1-.55-.23L.26 5.48A.9.9 0 0 1 0 4.84a.92.92 0 0 1 .28-.63l4.38-4A.77.77 0 0 1 5.8.3a.87.87 0 0 1-.08 1.2L2 4.88l3.74 3.64a.88.88 0 0 1 0 1.21.76.76 0 0 1-.59.27" />
  </svg>
);

export default ArrowBack;
